export default "__VITE_ASSET__C25dyv1r__"